'use client';

import { useUser } from '@medizzconnect/auth';
import { useState, useEffect } from 'react';

/**
 * Client-Side Hook: Prüft ob der eingeloggte User ein Admin ist.
 * Nutzt Clerk publicMetadata + einen API Call als Fallback.
 */
export function useIsAdmin(): { isAdmin: boolean; isLoading: boolean } {
  const { user, isLoaded } = useUser();
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!isLoaded) return;

    if (!user) {
      setIsAdmin(false);
      setIsLoading(false);
      return;
    }

    // 1. Schneller Check: Clerk publicMetadata
    const metadata = user.publicMetadata as Record<string, unknown> | undefined;
    if (metadata?.role === 'admin' || metadata?.role === 'super_admin') {
      setIsAdmin(true);
      setIsLoading(false);
      return;
    }

    // 2. API-Check (prüft DB admin_roles + SUPER_ADMIN_IDS)
    fetch('/api/admin/check')
      .then(res => res.json())
      .then(data => {
        setIsAdmin(data.isAdmin === true);
      })
      .catch(() => setIsAdmin(false))
      .finally(() => setIsLoading(false));
  }, [user, isLoaded]);

  return { isAdmin, isLoading };
}
